<template>
    <el-container>
        <el-drawer title="顶部菜单" :visible="formVisible" :before-close="handleClose" append-to-body
                   :wrapperClosable="false"
                   @open="handleOpen">
            <div style="height: calc(100% - 67px);">
                <el-scrollbar class="drawer_scrollbar">
                    <el-row style="padding: 30px">
                        <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                            <el-form-item label="菜单名称" prop="name">
                                <el-input v-model="form.name" placeholder="请输入菜单名称"/>
                            </el-form-item>
                            <el-form-item label="菜单编号" prop="code">
                                <el-input v-model="form.code" placeholder="请输入菜单编号"/>
                            </el-form-item>
                            <el-form-item label="图标" prop="icon">
                                <el-input v-model="form.icon" placeholder="请输入图标"/>
                            </el-form-item>
                            <el-form-item label="排序" prop="sort">
                                <el-input-number v-model="form.sort" :min="1" :max="999" />
                            </el-form-item>
                        </el-form>
                    </el-row>
                </el-scrollbar>
            </div>
            <el-row class="drawer_footer">
                <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
                <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
            </el-row>
        </el-drawer>
    </el-container>
</template>

<script>
    export default {
        name: "SysTopMenuForm",
        props: ['formVisible', 'submitUrl', 'selData'],
        data() {
            return {
                form: {},
                rules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'},
                        {max: 10, message: '长度不能大于10'}
                    ],
                    sort:[
                        {required: true, message: '请输入排序', trigger: 'blur'},
                    ]
                }
            };
        },
        methods: {
            handleOpen() {
                this.form = {...this.selData};
            },
            handleClose() {
                this.$refs.form.clearValidate();
                this.form = {};
                this.$emit('update:formVisible', false);
            },
            async submit() {
                let valid = await this.$refs.form.validate().catch(() => {
                });
                if (!valid) return;
                await this.postRequest(this.submitUrl, this.form);
                this.handleClose();
                this.$emit('refreshList')
            },
        }
    }
</script>

<style scoped>

</style>